import { defineStore } from 'pinia';
import { logout, refreshToken } from '@/services/api/auth.js';
import { carregarPermissoesDoServidor } from '@/services/api/permissionManagement.js';
import { getUser } from '@/services/api/auth.js';
import { voltarParaOAdmin } from '@/services/sso.js';

let refreshTimeout = null;

export const useAuthStore = defineStore('auth', {
    state: () => ({
        permissions: JSON.parse(localStorage.getItem('permissions') || 'null'),
        loadingPermissions: false,
    }),

    getters: {
        isAdmin: (state) =>
            state.permissions?.admin?.includes('*') && state.permissions?.allow?.includes('*'),
    },

    actions: {
        /**
         * Busca as permissoes no servidor. Diferente do admin, que le o cache
         * que o proprio login deixou: aqui nao houve login nesta origem, entao
         * o cache comeca vazio e precisa ser preenchido.
         */
        async fetchPermissions() {
            const usuario = getUser();

            if (!usuario?.id) {
                throw new Error('Sem usuario carregado para buscar permissoes.');
            }

            this.loadingPermissions = true;

            try {
                this.permissions = await carregarPermissoesDoServidor({ userId: usuario.id });
            } finally {
                this.loadingPermissions = false;
            }
        },

        /**
         * Renova o token um minuto antes de expirar. Se a renovacao falhar a
         * sessao acabou de verdade: encerra e devolve o usuario ao admin, que e
         * quem tem tela de login.
         */
        scheduleTokenRefresh() {
            clearTimeout(refreshTimeout);

            const exp = localStorage.getItem('tokenExp');
            if (!exp) return;

            const faltam = Number(exp) * 1000 - Date.now() - 60 * 1000;

            refreshTimeout = setTimeout(async () => {
                try {
                    await refreshToken();
                    this.scheduleTokenRefresh();
                } catch (error) {
                    console.error('Nao foi possivel renovar a sessao:', error);

                    await logout().catch(() => {});
                    this.$reset();
                    voltarParaOAdmin({
                        motivo: 'sessao-expirada',
                        retornarPara: window.location.pathname + window.location.search,
                    });
                }
            }, Math.max(faltam, 0));
        },
    },
});
